import { DefaultButton, PrimaryButton } from 'office-ui-fabric-react/lib/Button';
import Dialog, { DialogFooter, DialogType, ResponsiveMode } from 'office-ui-fabric-react/lib/Dialog';
import { Dropdown, DropdownMenuItemType } from 'office-ui-fabric-react/lib/Dropdown';
import { ComboBox, IComboBoxOption, IComboBoxProps, Spinner } from 'office-ui-fabric-react/lib/index';
import { mergeStyles } from 'office-ui-fabric-react/lib/Styling';
import { TextField } from 'office-ui-fabric-react/lib/TextField';
import * as React from 'react';
import { Label } from 'reactstrap';
import XRegExp from 'xregexp';
import { IAgentJurisdiction } from '../../../models/IAgentJurisdiction';
import { ICountry } from '../../../models/ICountry';
import { IModalDialog } from '../../../models/IModalDialog';
import { IContactInfoProps } from './IContactInfoProps';
import { IContactInfoState } from './IContactInfoState';

const getStyles = () => {
    return {
        root: {
            responsiveMode: true,
            color: '#005269'
        }
    }
};
const panel = mergeStyles({
    display: 'block',
    background: '#ffffff',
    boxShadow: '0px 0px 5px 5px #C9C9C9',
    padding: '10px',
    maxHeight: "400px",
    minWidth: '150px',
    fontSize: "12px", color: '#005269',
    overflowY: "scroll"
});
const topPanel = mergeStyles({
    display: 'block',
    background: '#ffffff',
    boxShadow: '0px 0px 5px 5px #C9C9C9',
    minHeight: '10px',
    marginTop: '5px',
    marginBottom: '5px',
    padding: '10px',
    fontSize: "13px",
    color: '#005269',
    minWidth: '200px',
    top: "0",
    maxWidth: "100%"
});
const profileTop = mergeStyles({
    display: 'inline-block', padding: "10px", verticalAlign: 'top', minWidth: "33%", maxWidth: "100%"
});
const profileTopDisabled = mergeStyles({
    display: 'inline-block', padding: "10px", verticalAlign: 'top', minWidth: "50%", maxWidth: "100%"
});
const profileBottom = mergeStyles({
    display: 'inline-block', padding: "10px", width: "100%", verticalAlign: 'top'
});
const alertMsgPanel = mergeStyles({
    color: "#E9512D", fontSize: "13px", textAlign: "left"
});
const submitButton = mergeStyles({ backgroundColor: '#F39000', marginRight: "5px" });
const submitButtonAlignment = mergeStyles({ textAlign: "center", margin: "0 auto" });
const selectedJurisdictionList = mergeStyles({ paddingTop: "5px", paddingBottom: "5px" });
export interface IDetailsList {
    key: string;
    CountryCode: string;
    Title: string;
}
export default class ContactInfo extends React.Component<IContactInfoProps, IContactInfoState>
{
    private dialog: IModalDialog;
    private VatError: string;
    private CPError: string;
    private CPEError: string;
    private CPPError: string;
    private FNError: string;
    private FA1Error: string;
    private FA2Error: string;
    private CTError: string;
    private STError: string;
    private CNTError: string;
    private PSTError: string;
    private SerCNTError: string;

    private allItems: IComboBoxOption[];

    constructor(props: IContactInfoProps, state: IContactInfoState) {
        super(props);
        this.VatError = '';
        this.CPError = '';
        this.FNError = '';
        this.FA1Error = '';
        this.FA2Error = '';
        this.CTError = '';
        this.STError = '';
        this.CNTError = '';
        this.PSTError = '';
        this.CPEError = '';
        this.CPError = '';
        this.CPPError = '';
        this.SerCNTError = '';

        this.allItems = [];
        this.state = {
            loading: false,
            agentMaster: {
                id: undefined,
                firmName: '',
                vatRegNo: '',
                emailId: '',
                firmAddress1: '',
                firmAddress2: '',
                city: '',
                state: '',
                countryCode: '',
                countryName: '',
                postalCode: '',
                contactPerson: '',
                companyEmail: '',
                phoneNumber: '',
                agentJurisdiction: []
            },
            inputError: 'This field is required',
            showError: false,
            isValidData: true,
            Relationships: [],
            selectedRelationship: {
                key: '',
                text: ''
            },
            Countries: [],
            selectedCountry: {
                key: '',
                text: ''
            },
            ServiceCountries: [],
            items: this.allItems,
            selectionDetails: [],
            referrer: false,
            saving: false,
            hideDialog: true,
            user: this.props.user,
            selectedItems: [],
            serviceJurisdiction: ""
        }
        this.dialog = {
            hideDialog: true,
            accessDeniedDialog: false,
            dialogMessage: '',
            dialogBody: '',
            mode: ''
        }
        this.loadCountries();
    }
    public async componentDidMount() {
        if (this.state.user.id !== null && this.state.user.id !== undefined && this.state.user.id !== "") {
            this.setState((prevState: IContactInfoState): IContactInfoState => {
                if (this.props.agentMaster.id === "" || this.props.agentMaster.id === undefined || this.props.agentMaster.id === null) {
                    prevState.agentMaster.emailId = prevState.user.email;
                    prevState.agentMaster.companyEmail = prevState.user.email;

                    prevState.agentMaster.contactPerson = prevState.user.firstName + " " + prevState.user.lastName;
                    prevState.agentMaster.phoneNumber = prevState.user.phoneNumber;
                }
                else {
                    prevState.agentMaster = this.props.agentMaster;
                    this.props.agentMaster.agentJurisdiction.sort((a, b) => a.countryName > b.countryName ? 1 : -1).forEach((item: IAgentJurisdiction) => {
                        prevState.selectionDetails.push(item.countryName);
                        prevState.serviceJurisdiction = prevState.serviceJurisdiction + item.countryName + ", ";
                    });
                    prevState.serviceJurisdiction = prevState.serviceJurisdiction.substr(0, prevState.serviceJurisdiction.length - 2);
                }
                return prevState;
            });
        }
    }
    public render(): React.ReactElement<IContactInfoProps> {
        const { selectionDetails } = this.state;
        return (
            <div className={topPanel} >
                {
                    (this.state.saving) && (
                        <div>
                            <div>
                                <Spinner label="Please wait..." />
                            </div>
                            <div>
                                <Dialog
                                    hidden={this.state.hideDialog}
                                    dialogContentProps={{
                                        type: DialogType.largeHeader,
                                        title: this.dialog.dialogMessage,
                                    }}
                                    maxWidth="1024px"
                                    closeButtonAriaLabel="Close"
                                >
                                    <div>
                                        <div>
                                            <Label> {this.dialog.dialogBody} </Label>
                                        </div>
                                    </div>
                                    <DialogFooter>
                                        <DefaultButton onClick={this.closeModelPopUp} data-automation-id="test" text="Ok" disabled={false} className={submitButton} iconProps={{ iconName: "CheckMark" }} />
                                    </DialogFooter>
                                </Dialog>

                            </div>
                        </div>)
                }
                {
                    (this.state.agentMaster.id && <div>
                        <div className={profileTopDisabled}>
                            <div>
                                <TextField label="Registered email address" placeholder="Registered email address" styles={getStyles}
                                    maxLength={40} value={this.props.agentMaster.emailId} disabled iconProps={{ iconName: "PublicEmail" }} />
                            </div>
                            <div>
                                <TextField label="Company Name" required styles={getStyles}
                                    maxLength={40} value={this.props.agentMaster.firmName} disabled />
                            </div>
                            <div>
                                <TextField label="VAT registration number" required styles={getStyles}
                                    maxLength={40} value={this.props.agentMaster.vatRegNo} disabled />
                            </div>
                            <div>
                                <TextField label="Contact person name" required styles={getStyles}
                                    maxLength={40} value={this.props.agentMaster.contactPerson} disabled />
                            </div>
                            <div>
                                <TextField label="Email address(Contact person)" required styles={getStyles}
                                    maxLength={40} value={this.props.agentMaster.companyEmail} disabled iconProps={{ iconName: "PublicEmail" }} />
                            </div>
                            <div>
                                <TextField label="Phone number" required styles={getStyles}
                                    maxLength={40} value={this.props.agentMaster.phoneNumber} disabled iconProps={{ iconName: "Phone" }} />
                            </div>
                        </div>
                        <div className={profileTopDisabled}>
                            <div>
                                <TextField label="Address Line1" required styles={getStyles}
                                    maxLength={40} value={this.props.agentMaster.firmAddress1} disabled />
                            </div>
                            <div>
                                <TextField label="Address Line2" required styles={getStyles} maxLength={40}
                                    value={this.props.agentMaster.firmAddress2} disabled />
                            </div>
                            <div>
                                <TextField label="Postal Code" required styles={getStyles} maxLength={40}
                                    value={this.props.agentMaster.postalCode} disabled />
                            </div>
                            <div>
                                <TextField label="City" required placeholder="City" styles={getStyles}
                                    maxLength={40} value={this.props.agentMaster.city} disabled />
                            </div>
                            <div>
                                <TextField label="State" styles={getStyles} maxLength={40}
                                    value={this.props.agentMaster.state} disabled />
                            </div>
                            <div>
                                <Dropdown
                                    id="ddCountry"
                                    placeHolder="--Select--"
                                    responsiveMode={ResponsiveMode.large}
                                    label="Country"
                                    options={this.state.Countries}
                                    required={true}
                                    styles={{ dropdown: { minWidth: 150 } }}
                                    errorMessage={this.CNTError}
                                    selectedKey={this.props.agentMaster.countryCode}
                                    disabled
                                />
                            </div>
                        </div>
                        <div className={profileBottom}>
                            <div>
                                <div className={selectedJurisdictionList}>Services offered for </div>
                                <div className={panel}>
                                    <div><strong>{this.state.serviceJurisdiction}</strong></div>
                                </div>
                            </div>
                        </div>
                    </div>)
                }
                {
                    (!this.state.saving && !this.state.agentMaster.id) && (
                        <div>
                            <div><strong>* Please enter all the required details below and select the countries/jurisdictions of your office(s).</strong></div>
                            <div className={profileTop}>
                                <div>
                                    <TextField label="Registered email address" placeholder="Registered email address" styles={getStyles}
                                        maxLength={320} value={this.state.agentMaster.emailId || this.state.user.email} disabled />
                                </div>

                                <div>
                                    <TextField label="Company Name" required placeholder="Company Name" styles={getStyles}
                                        maxLength={80} value={this.state.agentMaster.firmName} onChange={this.getErrorMessageFN} errorMessage={this.FNError} />
                                </div>

                                <div>
                                    <TextField label="VAT registration number" required placeholder="VAT registration number" styles={getStyles}
                                        maxLength={40} value={this.state.agentMaster.vatRegNo} onChange={this.getErrorMessageVT} errorMessage={this.VatError} />
                                </div>

                                <div>
                                    <TextField label="Contact person name" required placeholder="Contact person name" styles={getStyles}
                                        maxLength={80} value={this.state.agentMaster.contactPerson || this.state.user.firstName + " " + this.state.user.lastName} onChange={this.getErrorMessageCP} errorMessage={this.CPError} />
                                </div>
                                <div>
                                    <TextField label="Email address(Contact person)" required placeholder="Email address(Contact person)" styles={getStyles}
                                        maxLength={320} value={this.state.agentMaster.companyEmail || this.state.user.email} onChange={this.getErrorMessageEM}
                                        errorMessage={this.CPEError} iconProps={{ iconName: 'PublicEmail' }} />
                                </div>
                                <div>
                                    <TextField label="Phone number" required placeholder="Phone number(Contact person)" styles={getStyles}
                                        maxLength={15} value={this.state.agentMaster.phoneNumber || this.state.user.phoneNumber} onChange={this.getErrorMessagePN}
                                        errorMessage={this.CPPError} iconProps={{ iconName: 'Phone' }} />
                                </div>
                            </div>
                            <div className={profileTop}>
                                <div>
                                    <TextField label="Address Line1" required placeholder="Address Line1" styles={getStyles}
                                        maxLength={80} value={this.state.agentMaster.firmAddress1} onChange={this.getErrorMessageFA1} errorMessage={this.FA1Error} />
                                </div>

                                <div>
                                    <TextField label="Address Line2" placeholder="Address Line2" styles={getStyles} maxLength={80}
                                        value={this.state.agentMaster.firmAddress2} onChange={this.getErrorMessageFA2} errorMessage={this.FA2Error} />
                                </div>

                                <div>
                                    <TextField label="Postal Code" required placeholder="Postal Code" styles={getStyles} maxLength={10}
                                        value={this.state.agentMaster.postalCode} onChange={this.getErrorMessagePST} errorMessage={this.PSTError} />
                                </div>

                                <div>
                                    <TextField label="City" required placeholder="City" styles={getStyles}
                                        maxLength={40} value={this.state.agentMaster.city} onChange={this.getErrorMessageCT} errorMessage={this.CTError} />
                                </div>

                                <div>
                                    <TextField label="State" placeholder="State" styles={getStyles} maxLength={40}
                                        value={this.state.agentMaster.state} onChange={this.getErrorMessageST} errorMessage={this.STError} />
                                </div>
                                <div>
                                    <ComboBox
                                        label="Country"
                                        placeholder="Select or type"
                                        allowFreeform
                                        autoComplete="on"
                                        options={this.state.Countries}
                                        onChange={this.onChangeCountry}
                                        selectedKey={this.state.agentMaster.countryCode}
                                        errorMessage={this.CNTError}
                                        required
                                    />
                                </div>
                            </div>
                            <div className={profileTop}>
                                <div className={panel}>
                                    <div className={alertMsgPanel}>{this.SerCNTError}</div>
                                    <div>Select the jurisdiction(s) for which services are offered:</div>
                                    <div>(You can select multiple jurisdictions if you can provide <br />services in more than one jurisdiction)</div>
                                    <div>
                                        <ComboBox
                                            placeholder="Select or type"
                                            allowFreeform
                                            autoComplete="on"
                                            options={this.state.items}
                                            onChange={this.onChangeJurisdiction}
                                            multiSelect
                                            defaultSelectedKey={undefined}
                                        />
                                    </div>
                                    <div className={selectedJurisdictionList}>Selected jurisdictions: </div>
                                    <div>
                                        {
                                            selectionDetails.map((tech, i) => {
                                                return (
                                                    <div><strong>{tech.toString()}</strong></div>
                                                )
                                            })
                                        }
                                    </div>
                                </div>
                            </div>
                            <div><strong>* Please make sure that the information provided by you is true and accurate.</strong></div>
                            <div className={submitButtonAlignment} >
                                <span className={alertMsgPanel}> * </span> Mandatory  <br />
                                <PrimaryButton text="Submit" data-automation-id="test" onClick={this.submitForm} className={submitButton} iconProps={{ iconName: 'SaveAndClose' }} />
                            </div>
                        </div>
                    )
                }
            </div>
        );
    }
    private loadCountries(): void {
        var result: any = [];
        result.push(
            { key: '--Select--', text: '--Select--', itemType: DropdownMenuItemType.Header });

        this.props.connectionContext.get("Country")
            .then((countryList: ICountry[]): void => {
                this.setState((prevState: IContactInfoState): IContactInfoState => {
                    countryList = countryList.sort((a, b) => a.countryName > b.countryName ? 1 : -1)
                    countryList.forEach((item: ICountry) => {
                        result.push(
                            { key: item.countryCode, text: item.countryName })
                        this.allItems.push(
                            { key: item.countryCode, text: item.countryName })
                    });
                    prevState.Countries = result;
                    return prevState;
                });
            }).catch((error: any) => {
                this.handleError("Message", "Unable to process at the moment. Please try again or contact agent.network@zacco.com.");
            })
    }
    private onChangeCountry: IComboBoxProps['onChange'] = (event, option): void => {
        this.setState((prevState: IContactInfoState): IContactInfoState => {
            if (option !== undefined) {
                prevState.selectedCountry = option;
                this.CNTError = option.text.trim().length > 0 ? '' : 'Select a country';
                prevState.agentMaster.countryCode = option.key.toString();
                prevState.agentMaster.countryName = option.text.toString();
            }
            return prevState;
        });
    }
    private submitForm = async (): Promise<void> => {
        if (this.checkMandatoryFields()) {
            try {
                await this.props.connectionContext.post("Agent", this.state.agentMaster)
                this.setState((prevState: IContactInfoState): IContactInfoState => {
                    prevState.saving = true;
                    prevState.isValidData = true;
                    prevState.hideDialog = false;
                    this.handleError("Contact Information", "Contact information is successfully submitted. It's time to read and understand the terms of service in order to provide the charges.");
                    return prevState;
                });
            } catch (exception) {
                if (exception === 409) {
                    this.setState((prevState: IContactInfoState): IContactInfoState => {
                        prevState.saving = true;
                        prevState.isValidData = false;
                        prevState.hideDialog = false;
                        this.handleError("Warning", "Profile information has already been registered with Zacco.");
                        return prevState;
                    });
                } else {
                    this.setState((prevState: IContactInfoState): IContactInfoState => {
                        prevState.saving = true;
                        prevState.isValidData = false;
                        prevState.hideDialog = false;
                        this.handleError("Message", "Unable to process at the moment. Please try again or contact agent.network@zacco.com.");
                        return prevState;
                    });
                }
            }
        }
    }
    private checkMandatoryFields(): boolean {

        let validState: boolean = true;
        let VatregNo: boolean = this.state.agentMaster.vatRegNo.toString().trim().length > 0;
        let FirmName: boolean = this.state.agentMaster.firmName.toString().trim().length > 0;
        let FirmAddress1: boolean = this.state.agentMaster.firmAddress1.toString().trim().length > 0;
        let City: boolean = this.state.agentMaster.city.toString().trim().length > 0;
        let Country: boolean = this.state.agentMaster.countryCode.toString().trim().length > 0;
        let PostalCode: boolean = this.state.agentMaster.postalCode.toString().trim().length > 0;
        let ContactPerson: boolean = this.state.agentMaster.contactPerson.toString().trim().length > 0;
        let companyEmail: boolean = this.state.agentMaster.companyEmail.toString().trim().length > 0;
        let PhoneNoEntered: boolean = this.state.agentMaster.phoneNumber.toString().trim().length > 0; //&& isValidPhoneNumber(this.state.agentMaster.phoneNumber);

        if (!VatregNo) {
            this.VatError = 'VAT registration number is required';
            validState = false;
        }
        if (!FirmName) {
            this.FNError = 'Organization  Name is required';
            validState = false;
        }
        if (!ContactPerson) {
            this.CPError = 'Contact person name is required';
            validState = false;
        }
        if (!companyEmail) {
            this.CPEError = 'Email address is required';
            validState = false;
        }
        if (!PhoneNoEntered) {
            this.CPPError = 'Valid phone number is required';
            this.handleError("Warning", "Valid phone number is required.");
            validState = false;
        }
        if (!FirmAddress1) {
            this.FA1Error = 'Postal address is required';
            validState = false;
        }
        if (!City) {
            this.CTError = 'City is required';
            validState = false;
        }

        if (!Country) {
            this.CNTError = 'Country is required';
            validState = false;
        }
        if (!PostalCode) {
            this.PSTError = 'Postal code is required';
            validState = false;
        }
        if (this.state.ServiceCountries.length === 0) {
            this.SerCNTError = 'Select any country to which the agent is servicing';
            validState = false;
        }
        this.setState((prevState: IContactInfoState): IContactInfoState => {
            prevState.isValidData = validState;
            return prevState;
        });
        return validState;
    }
    private handleError(message: string, body: string) {
        this.dialog.dialogMessage = message;
        this.dialog.dialogBody = body;
        this.dialog.accessDeniedDialog = false;
        this.dialog.hideDialog = false;
        this.setState((previousState: IContactInfoState, props: IContactInfoProps): IContactInfoState => {
            previousState.hideDialog = false;
            return previousState;
        });
    }
    private closeModelPopUp = () => {
        this.setState((previousState: IContactInfoState, props: IContactInfoProps): IContactInfoState => {
            previousState.hideDialog = true;
            previousState.isValidData = false;
            previousState.saving = false;
            this.props.isAuthenticated();
            return previousState;
        });
    }
    private onChangeJurisdiction: IComboBoxProps['onChange'] = (event, option): void => {
        if (option) {
            this.setState((prevState: IContactInfoState): IContactInfoState => {
                const newSelectedItems = [...this.state.selectedItems];
                if (option.selected) {
                    newSelectedItems.push(option.key as string);
                    prevState.ServiceCountries.push({ key: option.key, text: option.text });
                    prevState.agentMaster.agentJurisdiction.push({ id: undefined, agentId: undefined, countryCode: option.key.toString(), countryName: option.text });
                    prevState.selectedItems = newSelectedItems;
                    prevState.selectionDetails.push(option.text);
                }
                else {
                    const currIndex = newSelectedItems.indexOf(option.key as string);
                    if (currIndex > -1) {
                        newSelectedItems.splice(currIndex, 1);
                        prevState.selectedItems = newSelectedItems;
                        prevState.ServiceCountries.forEach((listitem: IComboBoxOption) => {
                            if (option.text === listitem.text) {
                                let index = this.state.ServiceCountries.indexOf(listitem);
                                prevState.ServiceCountries = prevState.ServiceCountries.slice(0, index).concat(prevState.ServiceCountries.slice(index + 1));
                            }
                        });
                        prevState.agentMaster.agentJurisdiction.forEach((listitem: IAgentJurisdiction) => {
                            if (option.text === listitem.countryName) {
                                let index = this.state.agentMaster.agentJurisdiction.indexOf(listitem);
                                prevState.agentMaster.agentJurisdiction = prevState.agentMaster.agentJurisdiction.slice(0, index).concat(prevState.agentMaster.agentJurisdiction.slice(index + 1));
                            }
                        });
                        prevState.selectionDetails.forEach((listitem: string) => {
                            if (option.text === listitem) {
                                let index = this.state.selectionDetails.indexOf(listitem);
                                prevState.selectionDetails = prevState.selectionDetails.slice(0, index).concat(prevState.selectionDetails.slice(index + 1));
                            }
                        });
                    }
                }
                return prevState;
            });
        }
    }
    private getErrorMessageVT = (ev: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>, value?: string) => {
        this.setState((prevState: IContactInfoState): IContactInfoState => {
            const re = XRegExp('^[\\p{L}\\p{N} ]+$');
            let newValue = value || '';
            if (newValue.length < 1) {
                this.VatError = 'VAT registration number is required.';
                prevState.agentMaster.vatRegNo = '';
            }
            else if (!re.test(newValue)) {
                this.VatError = '';
                ev.preventDefault();
            }
            else {
                this.VatError = '';
                ev.preventDefault();
                prevState.agentMaster.vatRegNo = newValue.toUpperCase();
            }
            return prevState;
        });
    }
    private getErrorMessageFN = (ev: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>, value?: string) => {
        this.setState((prevState: IContactInfoState): IContactInfoState => {
            const re = XRegExp('^[\\p{L}\\p{Pd} ]+$');
            let newValue = value || '';
            if (newValue.length < 1) {
                this.FNError = 'Organization name is required.';
                prevState.agentMaster.firmName = '';
            }
            else if (!re.test(newValue)) {
                this.FNError = '';
                ev.preventDefault();
            }
            else {
                this.FNError = '';
                ev.preventDefault();
                prevState.agentMaster.firmName = newValue;
            }
            return prevState;
        });
    }
    private getErrorMessageCP = (ev: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>, value?: string) => {
        this.setState((prevState: IContactInfoState): IContactInfoState => {
            const re = XRegExp('^[\\p{L}\\p{Pd} ]+$');
            let newValue = value || '';
            if (newValue.length < 1) {
                this.CPError = 'Contact person name is required.';
                prevState.agentMaster.contactPerson = '';
            }
            else if (!re.test(newValue)) {
                this.CPError = '';
                ev.preventDefault();
            }
            else {
                this.CPError = '';
                ev.preventDefault();
                prevState.agentMaster.contactPerson = newValue;
            }
            return prevState;
        });
    }
    private getErrorMessageEM = (ev: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>, value?: string) => {
        this.setState((prevState: IContactInfoState): IContactInfoState => {
            let newValue = value || '';
            const re = /^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i;
            if (newValue.length < 1) {
                this.CPEError = 'Email address is required.';
                prevState.agentMaster.companyEmail = '';
            }
            else if (!re.test(newValue)) {
                this.CPEError = 'Enter a valid email address';
                prevState.agentMaster.companyEmail = newValue;
            }
            else {
                this.CPEError = '';
                prevState.agentMaster.companyEmail = newValue;
            }
            return prevState;
        });
    }
    private getErrorMessagePN = (ev: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>, value?: string) => {
        this.setState((prevState: IContactInfoState): IContactInfoState => {
            let newValue = value || '';
            const re1 = /^(\(?\+?[0-9]*\)?)?[0-9\- \(\)]*$/;
            if (newValue.length < 1) {
                this.CPPError = 'Phone number is required.';
                prevState.agentMaster.phoneNumber = '';
            }
            else if (!re1.test(newValue)) {
                this.CPPError = 'Enter a valid phone number.';
            }
            else if (re1.test(newValue) && newValue.length < 10) {
                this.CPPError = 'Enter a valid phone number.';
                prevState.agentMaster.phoneNumber = newValue;
            }
            else {
                this.CPPError = '';
                prevState.agentMaster.phoneNumber = newValue;
            }
            return prevState;
        });
    }
    private getErrorMessageFA1 = (ev: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>, value?: string) => {
        this.setState((prevState: IContactInfoState): IContactInfoState => {
            const re = XRegExp('^[\\p{L}\\p{N}\\p{P} ]+$');
            let newValue = value || '';
            if (newValue.length < 1) {
                this.FA1Error = 'Postal address is required.';
                prevState.agentMaster.firmAddress1 = '';
            }
            else if (!re.test(newValue)) {
                this.FA1Error = '';
                ev.preventDefault();
            }
            else {
                this.FA1Error = '';
                ev.preventDefault();
                prevState.agentMaster.firmAddress1 = newValue;
            }
            return prevState;
        });
    }
    private getErrorMessageFA2 = (ev: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>, value?: string) => {
        this.setState((prevState: IContactInfoState): IContactInfoState => {
            const re = XRegExp('^[\\p{L}\\p{N}\\p{P} ]+$');
            let newValue = value || '';
            if (newValue.length < 1) {
                prevState.agentMaster.firmAddress2 = '';
            }
            else if (!re.test(newValue)) {
                this.FA2Error = '';
                ev.preventDefault();
            }
            else {
                this.FA2Error = '';
                ev.preventDefault();
                prevState.agentMaster.firmAddress2 = newValue;
            }
            return prevState;
        });
    }
    private getErrorMessageCT = (ev: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>, value?: string) => {
        this.setState((prevState: IContactInfoState): IContactInfoState => {
            const re = XRegExp('^[\\p{L}\\p{Pd} ]+$');
            let newValue = value || '';
            if (newValue.length < 1) {
                this.CTError = 'City is required.';
                prevState.agentMaster.city = '';
            }
            else if (!re.test(newValue)) {
                this.CTError = '';
                ev.preventDefault();
            }
            else {
                this.CTError = '';
                ev.preventDefault();
                prevState.agentMaster.city = newValue;
            }
            return prevState;
        });
    }
    private getErrorMessageST = (ev: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>, value?: string) => {
        this.setState((prevState: IContactInfoState): IContactInfoState => {
            const re = XRegExp('^[\\p{L}\\p{Pd} ]+$');
            let newValue = value || '';
            if (!re.test(newValue)) {
                this.STError = '';
                ev.preventDefault();
            }
            else {
                this.STError = '';
                ev.preventDefault();
                prevState.agentMaster.state = newValue;
            }
            return prevState;
        });
    }
    private getErrorMessagePST = (ev: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>, value?: string) => {
        this.setState((prevState: IContactInfoState): IContactInfoState => {
            const re = /^[0-9A-Za-z ]+$/;
            let newValue = value || '';
            if (newValue.length < 1) {
                this.PSTError = 'Postal code is required.';
                prevState.agentMaster.postalCode = '';
            }
            else if (!re.test(newValue)) {
                this.PSTError = '';
                ev.preventDefault();
            }
            else if (re.test(newValue) && newValue.length < 4) {
                this.PSTError = 'Enter a valid postal code.';
                prevState.agentMaster.postalCode = newValue;
            }
            else {
                this.PSTError = '';
                ev.preventDefault();
                prevState.agentMaster.postalCode = newValue;
            }
            return prevState;
        });
    }
}